export const clientVersion = () => {
  // eslint-disable-next-line no-undef
  const describe = GIT_DESCRIBE;
  return `gol-appsync-vue-${describe.tag} (${describe.suffix})`;
};
